module.exports = __webpack_public_path__ + "static/adewale-07a231b7a4a37057e5211a6f077dfae2.png";